import { observer } from 'mobx-react';
import { henshu, useHenshu } from '@strategies/henshu';

import Section from '../Section';
import { COMAP_URL } from '../../config';
import ContactForm from '../ContactForm/ContactForm';
import { Callout, Pin } from '../MapIcons/MapIcons';
import homeIcon from '../../assets/home.svg';


export default observer(function Contact({ section }) {
    const { bindTo } = useHenshu();

    return (
        <Section index={4} name="Contact">
           <div className="row">
                <div className="engagement-content">
                    <div className="engagement-blurb">
                        <henshu.h3 {...bindTo('engagement.title')} />
                        <henshu.richtext {...bindTo('engagement.tagline')} />
                    </div>

                    <henshu.a
                        className="button with-arrow"
                        href={COMAP_URL}
                        {...bindTo('engagement.button')}
                    />

                    <div className={`engagement-animation ${section === 4 ? 'engage' : ''}`}>
                        <Callout term="animation.prompt1"/>
                        <Pin alt={''} icon={homeIcon} term="animation.icon5"/>
                    </div>
                </div>

                <ContactForm/>
            </div>
        </Section>
    );
});
